<template>
  <div v-if="preparePromotionList.length > 0">
    <p class="avoid" style="margin: 20px 0 5px;"><strong>Promotions: </strong></p>
    <table style=" border-collapse: collapse; border: 1px solid #cccccc; width: 100%">
      <tr style="background: #f3f3f3">
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Promotion Code</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left; width: 60%;">
          <p><strong>Promotion Detail</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Period of stay</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Min night</strong></p>
        </th>
        <th style="border: 1px solid #cccccc; padding: 3px; text-align: left;">
          <p><strong>Max night</strong></p>
        </th>
      </tr>
      <tr v-for="(promotion) of preparePromotionList" :key="`promotion-${promotion.id}`" class="avoid">
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top">
          <p>{{promotion.code}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top; width: 60%;">
          <p>{{promotion.detail}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top">
          <p><span v-html="bindPromotionPeriod(promotion.periodOfStayList)"></span></p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top">
          <p>{{promotion.minNight}}</p>
        </td>
        <td style="border: 1px solid #cccccc; padding: 3px; vertical-align: top">
          <p>{{promotion.maxNight}}</p>
        </td>
      </tr>
    </table>
    <div v-if="bindPromotionRemark().trim() !== ''" class="editor-preview avoid">
      <p style="margin: 5px 0 5px;">
        <strong>Remark: </strong>
      </p>
      <div v-html="bindPromotionRemark()"></div>
    </div>
  </div>
</template>
<script>
import { isValidStartEndInPeriod, getPeriodStartDate, getPeriodEndDate, dateFormat } from '@/helpers/datetime'
import { compact } from 'lodash'
import { REMARK_TYPE } from '@/configs/constant'
import { applyRemarkTableStyle } from '@/domains/contract-domain'

export default {
  name: 'Promotion',
  props: {
    contractStartDate: {
      type: String,
      default: ''
    },
    contractEndDate: {
      type: String,
      default: ''
    },
    promotionList: {
      type: Array,
      default: () => {
        return []
      }
    },
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    preparePromotionList: function () {
      const contractStartDate = this.contractStartDate
      const contractEndDate = this.contractEndDate

      const newPromotionList = this.promotionList.map((promotion) => {
        const periodOfStayList = promotion.periodOfStayList.map((item) => {
          if (isValidStartEndInPeriod(contractStartDate, contractEndDate, item.startDate, item.endDate)) {
            const startDate = getPeriodStartDate(contractStartDate, item.startDate)
            const endDate = getPeriodEndDate(contractEndDate, item.endDate)

            const newPeriod = {
              startDate: startDate,
              endDate: endDate
            }
            const newItem = Object.assign({}, item, newPeriod)

            return newItem
          }
        })
        const filteredPeriodOfStayList = compact(periodOfStayList)

        if (filteredPeriodOfStayList.length > 0) {
          const newPeriodOfStayList = {
            periodOfStayList: filteredPeriodOfStayList
          }
          const newPromotion = Object.assign({}, promotion, newPeriodOfStayList)

          return newPromotion
        }
      })

      const promotionList = compact(newPromotionList)

      return promotionList
    }
  },
  methods: {
    bindPromotionPeriod: function (periodList) {
      let periodStayStrList = []
      for (let period of periodList) {
        const periodStr = this._getDateFromTo(period.startDate, period.endDate)
        periodStayStrList.push(periodStr)
      }

      return periodStayStrList.join(', <br />')
    },
    _getDateFromTo: function (startDateStr, endDateStr) {
      let dateFromToStr = '-'
      if (startDateStr !== undefined && endDateStr !== undefined) {
        const startDate = new Date(startDateStr)
        const endDate = new Date(endDateStr)
        dateFromToStr = `${dateFormat.short(startDate, 'en')} - ${dateFormat.short(endDate, 'en')}`
      }

      return dateFromToStr
    },
    bindPromotionRemark: function () {
      const remark = applyRemarkTableStyle(this.remarkList, REMARK_TYPE.PROMOTION)

      return remark
    }
  }
}
</script>
<style scoped>
  p {
    display: block;
    margin-block-start: 0px;
    margin-block-end:0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .remark > p {
    margin: 5px 0 10px;
  }
</style>
